import React from "react";
import classNames from "classnames";
import PropTypes from 'prop-types';
import { AlertType } from "./alert.type";


const Alert = ({ icon, message, type }) => {
	const iconClass = classNames({
		"alert__box": true,
		"alert__box--success": type === AlertType.SUCCESS,
		"alert__box--error": type === AlertType.ERROR,
	});

	return (
		<div className={iconClass}>
			{icon}
			<p className="alert__box__message">{message}</p>
		</div>
	);
};

export default Alert;

Alert.propTypes = {
	message: PropTypes.string,
	icon: PropTypes.element,
	type: PropTypes.oneOf([AlertType.SUCCESS, AlertType.ERROR])
}